import React, { useEffect } from 'react';
import { useAgenda } from '../../hooks/agenda';

import { useAuth } from '../../hooks/auth';
import { useCategoria } from '../../hooks/categoria';
import { useClinica } from '../../hooks/clinica';
import { useFormaPagamento } from '../../hooks/formapagamento';
import { useMedico } from '../../hooks/medico';
import { usePerfil } from '../../hooks/perfil';
import { useModelo } from '../../hooks/modelo';

const SignOut: React.FC = () => {
  const { signOut } = useAuth();
  const { limparCategoria } = useCategoria();
  const { limparMedico } = useMedico();
  const { limparClinica } = useClinica();
  const { limparPerfil } = usePerfil();
  const { limparFormaPagamento } = useFormaPagamento();
  const { limparAgenda } = useAgenda();
  const { limparModelo } = useModelo();

  useEffect(() => {
    limparCategoria();
    limparMedico();
    limparPerfil();
    limparFormaPagamento();
    limparClinica();
    signOut();
    limparAgenda();
    limparModelo();
  }, [
    signOut,
    limparCategoria,
    limparClinica,
    limparFormaPagamento,
    limparPerfil,
    limparMedico,
    limparAgenda,
    limparModelo,
  ]);

  return <div />;
};

export default SignOut;
